import Text, { Inline } from 'components/base/Text';
import { Flex } from 'components/base/layout-components';
import styled from 'styled-components';
import moment from 'moment/moment';
import { METRICS_NOT_CLICKABLE } from '../GroupMetricsWidget.service';

const TooltipWrapper = styled(Flex)`
  background: rgba(255, 255, 255, 0.96);
  border-radius: 5px;
  border: 1px solid rgba(84, 103, 255, 0.2);
  box-shadow: 0 0 30px rgba(59, 89, 152, 0.15);
`;

const TrendLineToolTip = ({
  active,
  payload,
  displayLabel = '',
  widgetMetricName
}) => {
  const isDotClickable = !METRICS_NOT_CLICKABLE.includes(widgetMetricName);

  if (active && payload && payload.length) {
    const from = payload[0]?.payload?.point?.category?.after;
    const to = payload[0]?.payload?.point?.category?.before;

    let datesFormatted = '';

    if (from && to) {
      datesFormatted =
        from === to
          ? `${moment(from).format('MMM DD')}`
          : `${moment(from).format('MMM DD')} - 
      ${moment(to).format('MMM DD')}`;
    }

    return (
      <TooltipWrapper direction='column' pb='x-small'>
        <Text
          padding='0.7rem 1rem'
          size='medium'
          color='shuttleGray'
          weight='700'
          backgroundColor={datesFormatted ? 'catskillGray' : 'white'}
        >
          {datesFormatted}
        </Text>

        <Text
          padding='0.5rem 1rem'
          size='large'
          weight='700'
          color='shuttleGray'
        >
          {payload[0].payload?.displayValue}{' '}
          <Inline size='medium' color='shuttleGray'>
            {displayLabel?.toLowerCase()}
          </Inline>
        </Text>
        {isDotClickable && (
          <Text padding='0.5rem 1rem' color='shuttleGray'>
            Click point to view in Activity
          </Text>
        )}
      </TooltipWrapper>
    );
  }
  return null;
};
export default TrendLineToolTip;
